import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Image } from 'react-bootstrap';
import MyCarsButton from './MyCarsButton';

class SingleImage extends React.Component {
	constructor(props) {
		super(props);
		this.el = document.createElement('div');
		const [container, ..._otherContainers] = document.querySelectorAll(
			'.ddc-vehicle-image-mini'
		);
		this.containerEl = container;
	}

	componentDidMount() {
		if (this.containerEl) {
			this.containerEl.appendChild(this.el);
		}
	}

	componentWillUnmount() {
		if (this.containerEl) {
			this.containerEl.removeChild(this.el);
		}
	}

	render() {
		const singleImageProps = {
			src: this.props.image,
			responsive: true
		};
		if (this.props.onClick) {
			singleImageProps.onClick = this.props.onClick;
			singleImageProps.role = 'button';
		}
		// Use a portal to render the image into the sidebar
		return ReactDOM.createPortal(
			<div>
				<MyCarsButton
					transparent
					uuid={this.props.uuid}
					iconSize="large"
					trackGa={this.props.trackGa}
					myCars={this.props.myCars}
					myCarsSaveButtonClasses="position-absolute"
				/>
				<Image {...singleImageProps} />
			</div>,
			this.el
		);
	}
}

SingleImage.propTypes = {
	image: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	uuid: PropTypes.string.isRequired,
	trackGa: PropTypes.func.isRequired,
	myCars: PropTypes.shape({
		savedVehicles: PropTypes.arrayOf(PropTypes.shape())
	}).isRequired
};

SingleImage.defaultProps = {
	onClick: null
};

export default SingleImage;



// WEBPACK FOOTER //
// ./src/components/SingleImage.jsx